import React, { Component } from 'react';
import Input from '../../../../ui/input/Input';
import ReactTooltip from 'react-tooltip';
import ResetUsername from './ResetUsername';
import InputDatePicker from '../../../../ui/input/InputDatePicker.js';

class OrganizationInfo extends Component {
	_handleInputChange(e) {
    	this.props.onChange(e);
  	}

	_handleCreateUsername(e) {
		console.log("Create new username");
	}

	_handleDateChange(date) {
		this.props.onChangeAccountingDate(date);
		this.props.onChange(date);
	}

  	errorClass(error) {
	    return(error.length === 0 ? '' : 'has-error');
	}

	formatAccountingPeriod(dateBegin, dateEnd) {
		if(dateBegin) {
			const dateBeginDay = (dateBegin.replace(" 00:00:00", "")).slice(-2);
			const dateBeginMonth = dateBegin.slice(5,7);
			const dateEndDay = (dateEnd.replace(" 00:00:00", "")).slice(-2);
			const dateEndMonth = dateEnd.slice(5,7);
			return(dateBeginDay + '.' + dateBeginMonth + ' > ' + dateEndDay + '.' + dateEndMonth);
		} else {
			return ""
		}
	}

	render() {
		if(this.props.user.type === 'admin') {
			return(
				<div className="panel panel--half">
					<h2 style={{marginBottom: '2em'}}>{this.props.organization.type==='community' ? 'Trossamfundets' : 'Menighedens'} oplysninger</h2>
					<Input
				        type="text"
				        fullWidth={false}
				        placeholder="* Navn"
				        name="name"
				        autoComplete="off"
				        className={`${this.errorClass(this.props.errors.name)}`}
				        value={this.props.organization.name}
				        onChange={(e) => this._handleInputChange(e)}
				      />
			      	<Input
	                    type="text"
	                    fullWidth={false}
	                    placeholder="* Adresse"
	                    name="address"
	                    autoComplete="off"
	                    className={`${this.errorClass(this.props.errors.address)}`}
	                    value={this.props.organization.address}
	                    onChange={(e) => this._handleInputChange(e)}
	                  />
	                <Input
	                    type="text"
	                    fullWidth={false}
	                    placeholder="By"
	                    name="city"
	                    autoComplete="off"
	                    value={this.props.organization.city}
	                    onChange={(e) => this._handleInputChange(e)}
	                  />
	                <Input
	                    type="text"
	                    fullWidth={false}
	                    placeholder="Postnr."
	                    name="zip_code"
	                    autoComplete="off"
	                    value={this.props.organization.zip_code}
	                    onChange={(e) => this._handleInputChange(e)}
	                  />
	                <Input
	                    type="text"
	                    fullWidth={false}
	                    placeholder="Website"
	                    name="website"
	                    autoComplete="off"
	                    value={this.props.organization.website}
	                    onChange={(e) => this._handleInputChange(e)}
	                  />
	                <Input
	                    type="text"
	                    fullWidth={false}
	                    placeholder="Årstal for anerkendelse"
	                    name="approved_at"
	                    autoComplete="off"
	                    className={`${this.errorClass(this.props.errors.approved_at)}`}
	                    value={this.props.organization.approved_at}
	                    onChange={(e) => this._handleInputChange(e)}
	                  />
					<div className="flex items-center gap-4">
						<Input
							type="text"
							fullWidth={false}
							placeholder="CVR nr."
							name="vat_number"
							autoComplete="off"
							className={`${this.errorClass(this.props.errors.vat_number)}`}
							value={this.props.organization.vat_number}
							onChange={(e) => this._handleInputChange(e)}
						/>
						<div>
							{this.props.organization.id !== 0 && <ResetUsername vat_number={this.props.organization.vat_number} organizationId={this.props.organization.id} />}
						</div>
					</div>
					<h2 style={{marginTop: '2em'}}>Angivelse af regnskabsår</h2>
					<div className="flexbox">
						<Input
							type="text"
							fullWidth={false}
							placeholder={this.props.user.type==='user' ? "* Regnskabsår" : "Regnskabsår" }
							name="accounting_period"
							disabled="disabled"
							className={`${this.errorClass(this.props.errors.accounting_period)}`}
							autoComplete="off"
							onChange={(e) => this._handleInputChange(e)}
							value={this.formatAccountingPeriod(this.props.organization.accounting_period_begin, this.props.organization.accounting_period_end)}
						/>
						<InputDatePicker
							type="text"
							fullWidth={false}
							placeholder={this.props.user.type==='user' ? "* Regnskabsår" : "Regnskabsår" }
							name="accounting_period"
							autoComplete="off"
							onDateChange={(date) => this._handleDateChange(date)}
						/>
						<a onClick={(date) => this._handleDateChange(null)} style={{cursor: 'pointer', transform: 'translateY(25px)', position: 'relative', left: '30px'}}><img alt="Slet regnskabsperiode" src="/images/assets/kryds.svg" title="Slet regnskabsperiode" /></a>
					</div>
	            </div>
	      	)
		} else {
			return(
				<div className="panel panel--half">
					<ReactTooltip />
					<h2 style={{marginBottom: '2em'}}>{this.props.organization.type==='community' ? 'Trossamfundets' : 'Menighedens'} oplysninger <img src="/images/assets/info.svg" alt="info" data-html={true} data-tip="Dette felt kan kun redigeres af By-, Land- og Kirkeministeriet. <br/ >Ved behov for redigering af informationerne, kontakt da By-, Land- og Kirkeministeriet på tlf. nr. 33 92 33 90, <br/ >med sikker post via jeres digitale postkasse, der kan tilgås på www.virk.dk eller med ordinær post til By-, Land- og Kirkeministeriet, <br/ >Frederiksholms Kanal 21, 1220 København K." /></h2>
					<div>{this.props.organization.name}</div>
					<div>{this.props.organization.address}</div>
					<div>{this.props.organization.zip_code}</div>
					<div>{this.props.organization.city}</div>
					<div>{this.props.organization.website}</div>
					<div>CVR: {this.props.organization.vat_number}</div>
					<div>Anerkendt {this.props.organization.approved_at}</div>
					<div>Regnskabsår: {this.formatAccountingPeriod(this.props.organization.accounting_period_begin, this.props.organization.accounting_period_end)}</div>
				</div>
			)
		}
	}
}

export default OrganizationInfo;


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/OrganizationInfo.js